import React, { useState, useLayoutEffect, useCallback } from 'react';
const classNames = (className, loading) => {
    return className
        .split(/\s/)
        .map(name => loading ? `${name} ${name}-loading` : name)
        .join(' ');
};
const useStatus = (src) => {
    const [loaded, setLoaded] = useState(null);
    useLayoutEffect(() => () => setLoaded(null), [src]);
    const onLoad = useCallback(() => setLoaded(true), []);
    const onError = useCallback(() => setLoaded(false), []);
    return [loaded === null, loaded === false, onLoad, onError];
};
export default React.memo(function AsyncImage({ src, alt, placeholder, decoding = 'async', loading = 'lazy', className = 'async-image', }) {
    const [fetching, error, onLoad, onError] = useStatus(src);
    if (error && placeholder)
        return placeholder;
    const props = { alt, src, decoding, loading, onLoad, onError };
    return React.createElement("img", Object.assign({}, props, { className: classNames(className, fetching) }));
});
//# sourceMappingURL=index.js.map